<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_stock_change_record_viewmanage')">
				<template #search>
					<m-search ref="search" :init-data="initSearchData">
						<m-search-item label="仓库">
							<c-select name="warehouse_ids" async multiple @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="批次号" v-if="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="单据编号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="库存变更时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date" :clear="false"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_stock_change_record_export')" v-lock="lock('b_stock_change_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_change_record_export')" v-lock="lock('b_stock_change_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_stock_change_record_export')" v-lock="lock('b_stock_change_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_change_record_export')" v-lock="lock('b_stock_change_record_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<!--单据类型-->
				<template #order_type="{data}">
					<c-state dict="orderTypeName" :value="data.order_type"></c-state>
				</template>
				<!--库存类型-->
				<template #order_classify="{data}">
					<c-state dict="stockClassifyName" :value="data.order_classify"></c-state>
				</template>
				<!--【库存变更】数量-->
				<template #stock_change_count="{data}">
					<strong v-if="data.stock_change_count && data.stock_change_count > 0" style="color: green">{{data.stock_change_count}}</strong>
					<strong v-else-if="data.stock_change_count && data.stock_change_count < 0" style="color: red">{{data.stock_change_count}}</strong>
					<span v-else>{{data.stock_change_count}}</span>
				</template>
				<!--【盘点】备注-->
				<template #remark="{data}">
					<span v-if="data.remark">{{data.remark}}</span>
					<span v-else>-</span>
				</template>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		props: {
			in_product_code: String
		},
		data() {
			return {
				workType:25,
				initSearchData: {
					product_code: this.in_product_code||''
				}
			}
		},
		computed: {
		  // 获取dictName选项数据
		  ...mapState(['orderTypeName', 'systemConfig']),
		},
		methods: {
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>